function removeTripItem(rid, riid,riiname, ritype) {
    var req = new Object; 
    req.ReportID =rid;
    req.PlaceKey =riid;
    req.FullList=true;
    req.Mode="D";

    Page_Blur(true);
    var DTO = { 'Req': req }
    DynaProxy.invoke("UpdateReportItem", DTO, function (data) {   
        showSystemNotification("Item '" + riiname + "' has been removed from the trip and we are refreshing the page."); 
        Page_Blur(true);
        refreshWithQueryParam("tab",ritype);                           
    }, function (data) {    
        showSupportNotification('Unable to remove the item from the trip.');
    }) 
        
}

function QuickAddReportItem(rid, riid, ritype, rname, riname,callback, sid, sdt) {
    var req = new Object; 
    req.ReportID =rid;
    req.PlaceKey =riid;
    req.FullList=false;
    req.Mode="U";       
    req.Placetype=ritype;   
     if (req.Placetype == "CRU") {
        req.SailID =sid;
        req.SailDate=sdt;     
    }

    var DTO = { 'Req': req }
    DynaProxy.invoke("QuickAddReportItem", DTO, function (data) {
        if( typeof callback == "function" )  {callback(rid, riid,  ritype,  rname, riname,false);}
        else{  showSystemNotification(riname + "' has been added to the trip '" + rname + "'");}

    }, function (data) {
        if( typeof callback == "function" )  {callback(rid, riid,  ritype,  rname, riname,true);}
        else{showSupportNotification("Unable to add " + riname + "' to the trip '" +  rname + "'");}   
    }) 
        
}

function RemoveReportItem(rid, riid, rname, riname,ritype,callback) {
    var req = new Object; 
    req.ReportID =rid;
    req.PlaceKey =riid;
    req.FullList=true;       
    req.Placetype=ritype;
    req.Mode="D";        
    var DTO = { 'Req': req }
    DynaProxy.invoke("UpdateReportItem", DTO, function (data) {
        if( typeof callback == "function" )  {callback(rid, riid,  rname, riname,false);}
        else{  showSystemNotification(riname + " has been removed from the trip '" + rname + "'");}
    }, function (data) {             
        if( typeof callback == "function" )  {callback(rid, riid,  rname, riname,true);}
        else{showSupportNotification("Unable to remove " + riname + "' from the trip '" +  rname + "'");}

    }) 
}

function UpdateReportItem(rid, riid,  options, pois,  rname, riname,ritype,callback,msg) {
    var req = new Object; 
    req.ReportID =rid;
    req.PlaceKey =riid;
    req.FullList=true;
    req.Placetype=ritype;
    req.Mode="U";       
    req.ContentOptions=options;  
    req.POIKeys=pois; 

    if (req.Placetype == "CRU") {                   
        req.SailDate=getCruiseSailDate();
        req.SailID=getCruiseSailId();  
    }

    var DTO = { 'Req': req }
    DynaProxy.invoke("UpdateReportItem", DTO, function (data) {
        if( typeof callback == "function" )  {callback(rid, riid,  options,  rname, riname,false,msg);}
        else{  showSystemNotification(riname + "' has been updated in the trip '" + rname + "'");}
    }, function (data) {             
        if( typeof callback == "function" )  {callback(rid, riid,  options,  rname, riname,true,msg);}
        else{showSupportNotification("Unable to update " + riname + "' in the trip '" +  rname + "'");}

    }) 
}

function CreateQuickReport(riid,  options, pois,   riname,ritype,callback,msg) {
    var rname=riname;

    var req = new Object;  
    req.PlaceKey =riid;
    req.Placetype=ritype;
    req.Mode="Q";       
    req.ContentOptions=options;  
    req.POIKeys=pois; 
    req.Option2=rname;
    if (req.Placetype == "CRU") {                   
        req.SailID =getCruiseSailId();
        req.SailDate=getCruiseSailDate(); 
    }
  
    var DTO = { 'Req': req }
    DynaProxy.invoke("UpdateReportItem", DTO, function (data) {
        rid=data;
        callback(rid, riid,  options,  rname, riname,false,msg);
    }, function (data) {             
        callback("", riid,  options,  rname, riname,true,msg);
    }) 
}

